export enum DocumentStatus {
    Expired = "expired",
    ExpiringSoon = "expiring soon"
}